import { createRouter, createWebHistory } from "vue-router";
import { defaultTitle } from "../assets/scripts/config";
import List from "../views/UnitList.vue";
import UnitTitlesJson from "@/assets/json/unit_titles.json";
import LearningUnit01 from "../assets/json/learning_unit_01.json";
import LearningUnit02 from "../assets/json/learning_unit_02.json";
import LearningUnit03 from "../assets/json/learning_unit_03.json";
import store from "@/store/index.js";

const { unit_titles } = UnitTitlesJson;

const getUnitTitle = (unitTitles) => {
  const sideMenuTitle = unitTitles.side_menu_title;
  console.log(sideMenuTitle);
  const hasSideMenuTitle = !(
    sideMenuTitle === undefined || sideMenuTitle === ""
  );
  console.log(hasSideMenuTitle);
  return hasSideMenuTitle ? unitTitles.side_menu_title : unitTitles.title;
};

const routes = [
  {
    path: "/",
    name: "List",
    component: List,
    meta: { title: "精選古典探究 漢文編ホーム" },
    props: {
      unitTitlesJson: UnitTitlesJson,
    },
  },
  {
    path: "/a/",
    name: "a",
    component: () =>
      import(/* webpackChunkName: "A" */ "../views/LearningUnit.vue"),
    meta: { title: "漢文編Ⅰ部" },
    props: {
      unitTitle: getUnitTitle(unit_titles[0]),
      learningUnitJson: LearningUnit01,
    },
  },
  {
    path: "/b/",
    name: "b",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "漢文編Ⅱ部" },
    props: {
      unitTitle: getUnitTitle(unit_titles[1]),
      learningUnitJson: LearningUnit02,
    },
  },
  {
    path: "/c/",
    name: "c",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "附録" },
    props: {
      unitTitle: getUnitTitle(unit_titles[2]),
      learningUnitJson: LearningUnit03,
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.afterEach((to) => {
  document.title = to.meta.title || defaultTitle;
});

router.beforeEach(() =>{
  store.commit(
    "toggleDarkMode",
    localStorage.getItem("darkModeFrag") === "true"
  );
});

export default router;
